import { render } from "./ShareButton.vue?vue&type=template&id=1edb78f3&scoped=true&ts=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"

import "./ShareButton.vue?vue&type=style&index=0&id=1edb78f3&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edb78f3"]])

export default __exports__